import { Component } from '@angular/core';

@Component({
  selector: 'app-simple-layout',
  template: `<ng-content select="router-outlet"></ng-content>`,
})
export class SimpleLayoutComponent {}
